import { render, staticRenderFns } from "./bindActorDialog.vue?vue&type=template&id=490ee2be&scoped=true&"
import script from "./bindActorDialog.vue?vue&type=script&lang=js&"
export * from "./bindActorDialog.vue?vue&type=script&lang=js&"
import style0 from "./bindActorDialog.vue?vue&type=style&index=0&id=490ee2be&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490ee2be",
  null
  
)

export default component.exports